import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CalculationStore } from '../../../../../stores/calculation.store';
import { CalculationError } from '../../../../../../../../../../../common/src/errors/calculations/calculation.error';
import {
  calculationErrorMetadata,
} from '../../../../../../../../../../../common/src/metadatas/calculation-error.metadata';
import { TranslateService } from '@ngx-translate/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';
import {
  RolloverPropertyTransferredResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred.result';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  CalculationResponse,
} from '../../../../../../../../../../../common/dist/angular/responses/calculation.response';
import {
  CalculationStatusEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-status.enum';

@Component({
  selector: 'app-rollover-result',
  templateUrl: './rollover-result.component.html',
  styleUrls: ['./rollover-result.component.scss'],
  standalone: false,
})
export class RolloverResultComponent implements OnInit, OnDestroy {
  CalculationStatusEnum = CalculationStatusEnum;
  public calculationId: string;
  public calculationResponse: CalculationResponse;
  public options: RolloverOptions;
  public results: RolloverResult;
  isSectionCollapsed: boolean = false;
  selectedBadge: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
  private calculationResponseSubscription: Subscription;

  constructor(private readonly calculationStore: CalculationStore,
              private readonly translateService: TranslateService,
              private readonly activatedRoute: ActivatedRoute) {

    // Start by setting the calculationId
    this.calculationId = this.activatedRoute.snapshot.params.calculationId;

  }

  private _calculationStatusEnum: CalculationStatusEnum;

  get calculationStatusEnum(): CalculationStatusEnum {
    return this._calculationStatusEnum;
  }

  set calculationStatusEnum(value: CalculationStatusEnum) {
    this._calculationStatusEnum = value;
  }

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      if (params.calculationId === undefined) {
        return;
      }

      this.calculationId = params.calculationId;

      // Unsubscribe all the subscriptions on route change.
      this.unsubscribeAll();

      this.calculationResponseSubscription = this.calculationStore.get(params.calculationId).subscribe((calculationResponse) => {
        this.calculationStatusEnum = calculationResponse.status ?? this.calculationStatusEnum;

        // todo: add a mechanism to know if the results are simply loading (when calculationResponse === undefined) or there's an error (the other two conditions)
        if (calculationResponse === undefined || calculationResponse.options === undefined || calculationResponse.results === undefined) {
          return;
        }

        this.calculationResponse = calculationResponse;
        this.options = calculationResponse.options.options as RolloverOptions;
        this.results = calculationResponse.results.results as RolloverResult;
      });
      // To test the result component with an example response.
      // const calculationResponse = exampleResponse;
      // this.calculationResponse = calculationResponse;
      // this.options = calculationResponse.options.options as RolloverOptions;
      // this.results = calculationResponse.results.results as RolloverResult;
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  getPropertyTransferredOptionsFromResult(propertyTransferredResults: RolloverPropertyTransferredResult): RolloverPropertyTransferredOptions {
    return this.options.propertiesTransferred.find((property) => property.id === propertyTransferredResults.id);
  }

  getErrorText(error: string | CalculationError) {
    if (typeof error === 'string') {
      return error;
    }

    if (error.hasOwnProperty('calculationErrorKeyname')) {
      const calculationError = calculationErrorMetadata[error.calculationErrorKeyname];

      if (calculationError === undefined) {
        return 'Erreur inconnue'; // todo: translate this.
      }

      if (calculationError.i18n.hasOwnProperty(this.translateService.currentLang) && calculationError.i18n[this.translateService.currentLang] !== '') {
        return calculationError.i18n[this.translateService.currentLang];
      }

      return calculationError.i18n.fr;
    }
  }

  private unsubscribeAll() {
    this.calculationResponseSubscription?.unsubscribe();
  }
}
